// jshint esversion: 8

export default {
  SET_DATA: (state, payload) => state.data = payload
};
